import { render, staticRenderFns } from "./PasswordResetLinkRequest.vue?vue&type=template&id=4633f531&"
import script from "./PasswordResetLinkRequest.vue?vue&type=script&lang=js&"
export * from "./PasswordResetLinkRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports